/**
 * 약관동의관련 
 * 마케팅 활용 동의, 광고성 정보 수신 동의의 변경에 따른 처리 로직
 */

import ConstTerms from "../helpers/ConstTerms";
export const TermsCheckMixin = {
  data() {
    return {
      terms: [],
      adTerms: [],
    }
  },
  computed: {
    termMarketingChecked(){
      let term = this.terms.find((t)=> t.key == ConstTerms.MARKETING);
      return (term) ? term.checked : false;
    },

    termAdReceiveChecked(){
      let term = this.terms.find((t)=> t.key == ConstTerms.AD_RECEIVE_AGREE);
      return (term) ? term.checked : false;
    },

    adTermschecked(){
      let term = this.adTerms.find((t)=> t.checked == true);
      return (term) ? term.checked : false;
    },
  },
  watch: {
    termMarketingChecked(v) { this.changeTermMarketingChecked(v); },
    termAdReceiveChecked(v) { this.changeTermAdReceiveChecked(v); },
    adTermschecked(v) { this.changeAdTermschecked(v); },
  },
  methods: {
    changeTermMarketingChecked(v){
      if(!v) {
        let term = this.terms.find((t)=> t.key == ConstTerms.AD_RECEIVE_AGREE);
        if(term) term.checked = false;
      }
    },

    changeTermAdReceiveChecked(v){
      if(v) {

        let term = this.terms.find((t)=> t.key == ConstTerms.MARKETING);
        if(term) term.checked = true;

        if(!this.adTermschecked)
          this.adTerms.forEach(adTerm => { adTerm.checked = true; });

      } else {
        this.adTerms.forEach(adTerm => { adTerm.checked = false; });
      }
    },

    changeAdTermschecked(v){
      if(v) {
        let term = this.terms.find((t)=> t.key == ConstTerms.AD_RECEIVE_AGREE);
        if(term) term.checked = true;
      } 
    }
  }
}